import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BookingActions = ({ location, participants, meetingDate, meetingTime }) => {
  const [copied, setCopied] = useState(false);

  const handleAddToCalendar = () => {
    const title = `Meeting at ${location?.name}`;
    const details = `Meeting with ${participants?.map(p => p?.name)?.join(', ')}\n\nLocation: ${location?.name}\nAddress: ${location?.address}\nPhone: ${location?.phone || 'N/A'}`;
    const locationStr = location?.address;
    
    // Google Calendar URL
    const startDate = new Date()?.toISOString()?.replace(/[-:]/g, '')?.split('.')?.[0] + 'Z';
    const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(locationStr)}&dates=${startDate}/${startDate}`;
    
    window.open(calendarUrl, '_blank');
  };

  const handleShareSMS = () => {
    const message = `Meeting confirmed at ${location?.name} (${location?.address}) on ${meetingDate} at ${meetingTime}. See you there!`;
    window.open(`sms:?body=${encodeURIComponent(message)}`);
  };

  const handleShareEmail = () => {
    const subject = `Meeting Confirmation - ${location?.name}`;
    const body = `Hi everyone,\n\nOur meeting has been confirmed!\n\nDate: ${meetingDate}\nTime: ${meetingTime}\nLocation: ${location?.name}\nAddress: ${location?.address}\nPhone: ${location?.phone || 'N/A'}\n\nParticipants:\n${participants?.map(p => `- ${p?.name} (${p?.location})`)?.join('\n')}\n\nLooking forward to seeing you there!`;
    
    window.open(`mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
  };

  const handleCopyDetails = () => {
    const details = `Meeting Details\n\nDate: ${meetingDate}\nTime: ${meetingTime}\nLocation: ${location?.name}\nAddress: ${location?.address}\nPhone: ${location?.phone || 'N/A'}\n\nParticipants:\n${participants?.map(p => `- ${p?.name}`)?.join('\n')}`;
    
    navigator.clipboard?.writeText(details)?.then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleBookTable = () => {
    // In real app, this would integrate with booking systems
    alert(`Booking feature would open reservation system for ${location?.name}`);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 shadow-md">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Share2" size={24} className="text-primary" />
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground">
          Share & Book
        </h2>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className="text-base font-semibold text-foreground mb-3">Share Meeting Details</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <Button
              variant="outline"
              iconName="Calendar"
              iconPosition="left"
              onClick={handleAddToCalendar}
              className="justify-start"
            >
              Add to Calendar
            </Button>
            <Button
              variant="outline"
              iconName="MessageSquare"
              iconPosition="left"
              onClick={handleShareSMS}
              className="justify-start"
            >
              Send SMS
            </Button>
            <Button
              variant="outline"
              iconName="Mail"
              iconPosition="left"
              onClick={handleShareEmail}
              className="justify-start"
            >
              Send Email
            </Button>
            <Button
              variant="outline"
              iconName={copied ? "Check" : "Copy"}
              iconPosition="left"
              onClick={handleCopyDetails}
              className="justify-start"
            >
              {copied ? 'Copied!' : 'Copy Details'}
            </Button>
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <h3 className="text-base font-semibold text-foreground mb-3">Reservation</h3>
          <div className="bg-muted rounded-lg p-4 mb-4">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} className="text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Booking Recommended</p>
                <p className="text-sm text-muted-foreground">
                  For venues like {location?.type?.toLowerCase()}s, we recommend making a reservation to ensure availability for your group of {participants?.length} people.
                </p>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <Button
              variant="default"
              iconName="CalendarCheck"
              iconPosition="left"
              onClick={handleBookTable}
              size="lg"
            >
              Book Table/Space
            </Button>
            <Button
              variant="outline"
              iconName="Phone"
              iconPosition="left"
              onClick={() => window.open(`tel:${location?.phone}`)}
              size="lg"
            >
              Call Venue
            </Button>
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <h3 className="text-base font-semibold text-foreground mb-3">Additional Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-background border border-border rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Cloud" size={18} className="text-primary" />
                <span className="text-sm font-medium text-foreground">Weather Forecast</span>
              </div>
              <p className="text-sm text-muted-foreground">Partly cloudy, 72°F</p>
            </div>
            <div className="bg-background border border-border rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Icon name="Car" size={18} className="text-primary" />
                <span className="text-sm font-medium text-foreground">Parking</span>
              </div>
              <p className="text-sm text-muted-foreground">Street parking available nearby</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingActions;